// Markdown -> safe HTML for briefs and Assistant replies. Raw HTML in the source is shown as text (never injected) and
// only http(s)/mailto/relative links survive — brief and chat text can carry issue titles and other people's words.
import { Marked } from 'marked';

const esc = (s: string): string => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

const SAFE_HREF = /^(https?:|mailto:|#|\/(?!\/))/i;

const md = new Marked({
  gfm: true,
  breaks: true,
  walkTokens(token) {
    if (token.type === 'html') {
      const t = token as unknown as { type: string; text: string; raw: string };
      t.type = 'text'; t.text = esc(t.raw);
    } else if (token.type === 'link' || token.type === 'image') {
      const t = token as unknown as { href: string };
      if (!SAFE_HREF.test(t.href.trim())) t.href = '#';
    }
  },
});

// Fenced code gets a header with the language and a Copy button (wired by event delegation in <Prose>).
md.use({
  renderer: {
    code(code: string, infostring: string | undefined) {
      const lang = (infostring ?? '').trim().split(/\s+/)[0].replace(/[^A-Za-z0-9_+.-]/g, '');
      return `<div class="code-block"><div class="code-head"><span>${esc(lang)}</span><button type="button" class="copy-btn" data-copy>Copy</button></div>` +
        `<pre><code${lang ? ` class="language-${lang}"` : ''}>${esc(code)}\n</code></pre></div>`;
    },
  },
});

export function renderMarkdown(src: string): string {
  return md.parse(src ?? '', { async: false }) as string;
}
